import React from 'react';
import { connect } from 'react-redux'
import {
  show_sidebar_feed_actions,
  hide_sidebar_feed_actions,
  get_project,
  create_optimized_feed,
  reset_feed_errors,
  update_xml,
  upload_new
} from '../actions/'
// import { Link, Redirect } from 'react-router-dom'
import { Redirect } from 'react-router-dom'
import {
  is_logged_on,
  is_validating
 } from "../helpers"
 import {
  Form,
  Control,
  actions
  // Errors
} from 'react-redux-form'
import ProjectOptimizations from './ProjectOptimizations';
import Loading from './Loading';
import Errors from './Errors'

const mapStateToProps = state => {
  return {
    feed: state.feed.feed,
    mustRedirect: state.feed.mustRedirect,
    fetching: state.feed.fetching,
    fetched: state.feed.fetched,
    creating_optimized: state.feed.creating_optimized,
    errors: state.feed.errors
  };
};

const mapDispatchToProps = dispatch => {
    return {
      getProject: (id, page, refreshing) => dispatch ( get_project(id, page, refreshing) ),
      createOptimized: (id, feedData) => dispatch( create_optimized_feed(id, feedData) ),
      resetForm: () => dispatch( actions.reset('newFeed') ),
      showActions: () => dispatch ( show_sidebar_feed_actions() ),
      hideActions: () => dispatch ( hide_sidebar_feed_actions() ),
      resetErrors: () => dispatch ( reset_feed_errors() ),
      updateXml: (id, page) => dispatch ( update_xml(id, page) ),
      uploadNew: (id, formData) => dispatch ( upload_new(id, formData) ),
    }
}

class ConnectedProject extends React.Component {
  constructor () {
    super()
    this.state = {
      isHiddenNewFeedForm: true,
      intervalTimer: false
    }
  }

  handleSubmit(values) {
    const { id } = this.props.match.params
    this.props.createOptimized(id, values)

  }

  componentDidUpdate(prevProps, prevState) {

    const creating_optimized = this.props.creating_optimized
    const prev_creating_optimized = prevProps.creating_optimized

    if ( creating_optimized !== prev_creating_optimized ) {
      if ( prev_creating_optimized ) {
        this.toggleHidden()
        this.props.resetForm()
        // this.props.resetErrors()
      }
    }
  }


  componentDidMount() {
    const { id } = this.props.match.params
    this.props.showActions()
    this.props.getProject( id, 1, false )
  }

  componentWillUnmount() {
    this.props.hideActions()
    this.props.resetForm()
    this.props.resetErrors()
    if ( this.state.intervalTimer !== false ) {
      clearInterval(this.state.intervalTimer)
    }
  }

  toggleHidden () {
    this.setState({
      isHiddenNewFeedForm: !this.state.isHiddenNewFeedForm
    })
    this.props.resetErrors()
  }

  render() {
    const isHidden = this.state.isHiddenNewFeedForm;
    const {fetching, fetched, errors, resetErrors} = this.props

    if ( !is_validating() && !is_logged_on() ) {
      return <Redirect to="/" />
    }

    if (fetching) {
      return (
       <Loading />
      )
    }


    if ( !fetching && !fetched && errors !== undefined && errors !== null && errors.length > 0 ) {
      window.M.toast({
        html: errors
      })
      resetErrors()
      return <Redirect to="/" />
    }

    const {feed, getProject} = this.props;
    const {last_update, status, next_sync, active, total_items} = feed;
    const pagination = (this.props.feed.pagination === undefined || this.props.feed.pagination === null) ? {} : this.props.feed.pagination

    const optimizations = (typeof( this.props.feed.optimizations ) === "undefined") ? [] : this.props.feed.optimizations

    const optimizationsLength = optimizations.length;
    let hasOptimizations;

    let autoReload = false;

    if ( optimizationsLength > 0 ) {

      for(var i = 0; i < optimizationsLength; i++) {
        if ( optimizations[i].xml_pending === true || optimizations[i].entries === 0 || optimizations[i].xml_updating ) {
          autoReload = true
        }
      }

      hasOptimizations = <ProjectOptimizations optimizations={optimizations} pagination={pagination} feed_id={this.props.match.params.id} />
    }

    if ( typeof(status) !== "undefined" &&  status.match(/^working/) ) {
      autoReload = true
      hasOptimizations = <ProjectOptimizations optimizations={optimizations} pagination={pagination} feed_id={this.props.match.params.id} />

    }

    if ( autoReload ) {
      if ( this.state.intervalTimer === false) {
        const timer =  setInterval(function() {
          const feed_id = feed.id
          const { page } = pagination
          getProject( feed_id, page, true )
        }, 5000)
        this.setState({intervalTimer: timer})
      }
    } else {
      if ( this.state.intervalTimer !== false ) {
        clearInterval(this.state.intervalTimer)
        this.setState({intervalTimer: false})
      }
    }

    //condition
    // let status = "working";
    // const syncStatus = false;
    let icon, iconTitle;
    let syncError = false;

    if ( active === false ) {
      icon = <i className="material-icons c-red">delete</i>;
      iconTitle = "This porject is archived"
    } else if ( typeof(status) !== "undefined" && status.match(/^idle/i)) {
      icon = <i className="material-icons c-light-green">sync</i>;
      iconTitle = "Project has synchronized succesfully"
    } else if (typeof(status) !== "undefined" &&  status.match(/^working/) ) {
      icon = <i className="material-icons orange-text">hourglass_empty</i>;
      iconTitle = "Project is currently synchronizing"
    } else {
      icon = <i className="material-icons c-red">sync_problem</i>;
      iconTitle = "Errors on last synchronization"
      syncError = true;
    }

    let syncTimestamp = ''
    if ( typeof(last_update) !== "undefined" && last_update.length > 0 ) {
      syncTimestamp = (
        <div>Last sync at {new Date(last_update).toLocaleDateString()}, {new Date(last_update).toLocaleTimeString()}</div>
      )
    }

    let nextSyncTimestamp = ''
    if ( typeof(next_sync) !== "undefined" && next_sync !== null && next_sync.length > 0 ) {
      nextSyncTimestamp = (
        <div>Next sync at {new Date(next_sync).toLocaleDateString()}, {new Date(next_sync).toLocaleTimeString()}</div>
      )
    }


    return (
      <div>
        <div className="collection with-header">
          <div className="collection-header red darken-1 white-text">
            <span className="flow-text">{feed.name}</span>
          </div>

          <div className="collection-header">
            <div className="flex align-center justify-between">
              <div className="flex flex-left align-center" title={(total_items===0 && syncError) ? "There are no items in this feed. Is the URL correct?" : ""}>
                <h5 className="mr-10">Instances</h5>
                <button className={`btn red darken-1 waves-effect waves-light ${active ? '' : 'hide'}`}
                        onClick={this.toggleHidden.bind(this)} disabled={total_items === 0}>
                  Add New
                </button>
                {
                  syncError && <span className="c-red" style={{marginLeft: 10,fontSize: 10,fontWeight: 'bold',paddingTop: 24}}>Sync Error: {status}</span>
                }
              </div>
              <div className="flex flex-right align-center relative">
                {
                  (feed.feed_type !== 'textfile' && feed.feed_type !== 'excelfile') ? (
                    <React.Fragment>
                      <div className="flex align-center mr-5" title={iconTitle}>Sync Status: {icon}</div>
                      <button className={`btn light-green waves-effect waves-light btn-small ${active ? '' : 'hide'}`} onClick={e=>{
                        e.preventDefault()
                        const { id } = this.props.match.params
                        const { page } = this.props.feed.pagination
                        this.props.updateXml(id, page)
                      }}>Sync Now</button>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <button
                        className={`btn light-green waves-effect waves-light btn-small ${active ? '' : 'hide'}`}
                        disabled={status.match(/^working/)}
                        onClick={e=>{
                        e.preventDefault()
                        document.getElementById('uploadnewfeed').click()
                      }}>Upload New</button>
                      <input type="file" id="uploadnewfeed" style={{display:'none'}} onChange={e=>{
                        let formData = new FormData()
                        const { id } = this.props.match.params
                        const { page, per_page } = this.props.feed.pagination
                        formData.append('file', e.target.files[0])
                        formData.append('per_page', per_page)
                        formData.append('page', page)
                        this.props.uploadNew(id, formData)
                      }}/>
                    </React.Fragment>
                  )
                }

                <div className="last-sync">
                  { active ? syncTimestamp : '' }
		              { active ? nextSyncTimestamp : '' }
                </div>
              </div>
            </div>

            <Form
              model="newFeed"
              className={isHidden ? 'hide' : ''}
              onSubmit = { (values) => {
                this.handleSubmit(values)
              }}
            >
              <div className="section">
                <div className="input-field">
                  <label htmlFor="thename">Add a name for the new feed instance</label>
                  <Control.text id="thename" model= "newFeed.name" />

                </div>
              </div>

              <Errors errors={this.props.errors} />
              <div className="section">
                <button type="submit" className="btn red darken-1 waves-effect waves-light">ADD NEW FEED INSTANCE<i className="material-icons right">navigate_next</i></button>
              </div>
            </Form>

            <p className="project_url"><span className="bold">Original Feed Url: </span>{feed.feed_type === 'textfile' ? 'Uploaded from file' : feed.url}</p>
          </div>

          {hasOptimizations}

        </div>
      </div>
    )
  }
}

const Project = connect(mapStateToProps, mapDispatchToProps)(ConnectedProject);

export default Project;



// WEBPACK FOOTER //
// ./src/js/components/Project.js